import { ArrowRight, MapPin, Phone, Mail, MessageCircle, Clock } from "lucide-react";
import Reveal from "./Reveal";
import { NAV_LINKS, waLink, WA_MESSAGES, WA_DISPLAY } from "../../data";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0F1115] pb-28 md:pb-0">
    <div className="border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
        <Reveal>
          <p className="font-tech mb-6 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/50">
            <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
            Get a Quote
            <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
          </p>
          <div className="flex flex-wrap items-end justify-between gap-10">
            <h2 className="font-display max-w-2xl text-4xl font-semibold uppercase leading-[1.05] tracking-wide text-white sm:text-5xl lg:text-6xl">
              BUTUH STEGER UNTUK
              <br />
              PROYEK ANDA<span className="text-[#DF9F00]">?</span>
            </h2>
            <div>
              <p className="mb-6 max-w-sm text-base leading-relaxed text-white/55">
                Hubungi kami untuk mendapatkan penawaran.
              </p>
              <a
                href={waLink(WA_MESSAGES.quote)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-cta"
                className="group inline-flex items-center gap-3 rounded-lg bg-[#DF9F00] px-8 py-4 text-sm font-bold uppercase tracking-[0.12em] text-[#141619] transition-colors duration-300 hover:bg-white"
              >
                Hubungi via WhatsApp
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="inline-flex items-center rounded-xl bg-white px-4 py-3">
            <img
              src="/images/logo-full.png"
              alt="CV Mitra Bangun Utama — General Supplier & Scaffolding"
              className="h-12 w-auto"
              data-testid="footer-brand-logo"
            />
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/50">
            Sewa &amp; Jual Steger untuk Kebutuhan Konstruksi.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-tech mb-6 text-[10px] uppercase tracking-[0.28em] text-[#DF9F00]">
            Navigasi
          </p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-${l.testid}`}
                  className="text-sm text-white/60 transition-colors duration-300 hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-tech mb-6 text-[10px] uppercase tracking-[0.28em] text-[#DF9F00]">
            Kontak
          </p>
          <ul className="space-y-4 text-sm text-white/60">
            <li className="flex items-start gap-3">
              <MessageCircle className="mt-0.5 h-4 w-4 shrink-0 text-[#DF9F00]" />
              <a
                href={waLink(WA_MESSAGES.general)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="transition-colors hover:text-white"
              >
                WhatsApp: {WA_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[#DF9F00]" />
              <span data-testid="footer-phone">Phone: {WA_DISPLAY}</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-[#DF9F00]" />
              <a
                href="mailto:info@mitrabangunutama.co.id"
                data-testid="footer-email"
                className="transition-colors hover:text-white"
              >
                info@mitrabangunutama.co.id
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#DF9F00]" />
              <a
                href="https://maps.app.goo.gl/WrAVJ7BKfKiNDK3Z7"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address"
                className="transition-colors hover:text-white"
              >
                Kedaung Kali Angke, Cengkareng, Jakarta Barat, DKI Jakarta 11720
                <span className="mt-1 block text-xs text-[#DF9F00]">
                  Lihat di Google Maps →
                </span>
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-[#DF9F00]" />
              <span>Senin – Sabtu, 08.00 – 17.00 WIB</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-6 lg:px-8">
        <p className="font-tech text-[10px] uppercase tracking-[0.2em] text-white/40">
          © 2026 CV Mitra Bangun Utama. All rights reserved.
        </p>
        <p className="font-tech text-[10px] uppercase tracking-[0.2em] text-white/40">
          Scaffolding Rental &amp; Sales
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
